/*
 * NextGenn engine · the WhatsApp button, awake (snippets/ngs-whatsapp.liquid).
 *
 * A disc pinned to a corner from the first paint becomes furniture, and nobody
 * reads furniture. This gives it three moments and no more:
 *
 *   · it ARRIVES a second after the page, rising into place rather than being
 *     part of the wallpaper;
 *   · it SAYS WHAT IT IS once, opening to its full label for a few seconds the
 *     first time the visitor has actually started reading, then closing again;
 *   · it OFFERS ITSELF at the moment a question forms, which is when somebody
 *     has read a long way down a page and stopped. On a bottle's page it offers
 *     itself by name: "Ask about the Serum".
 *
 * Once per page, at most twice per session, never while the page is moving.
 * With motion turned off, none of it happens and the button is simply there.
 *
 * No timers are left running: everything is a scroll listener that removes
 * itself once the session's two openings are spent.
 */
(function () {
  var wa = document.querySelector('[data-ngs-wa]');
  if (!wa) return;

  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var KEY = 'ngs-wa-said';
  var opened = 0;
  try {
    opened = Number(window.sessionStorage.getItem(KEY)) || 0;
  } catch (error) {
    opened = 0;
  }

  /* Motion off: it is there, at once, and it never moves again. */
  if (still) {
    wa.classList.add('is-in');
    return;
  }

  var shut = null;
  var waiting = null;
  var last = window.scrollY;
  var travelled = 0;

  function remember() {
    opened += 1;
    try {
      window.sessionStorage.setItem(KEY, String(opened));
    } catch (error) {
      /* a private window: it simply opens again next page, which is no harm */
    }
  }

  function open(hold) {
    if (wa.classList.contains('is-open')) return;
    wa.classList.add('is-open');
    remember();
    clearTimeout(shut);
    shut = setTimeout(function () {
      wa.classList.remove('is-open');
    }, hold);
  }

  /* Arrive. The delay is the point: the page settles, and then something new
     appears, which is the only way a fixed element is ever noticed. */
  setTimeout(function () {
    wa.classList.add('is-in');
    /* The first opening waits for the visitor to be reading rather than
       landing: a label that fires at zero scroll is a pop-up. */
    if (opened === 0) {
      waiting = setTimeout(function () {
        if (window.scrollY > 200) open(4200);
      }, 2600);
    }
  }, 900);

  var resting;
  function onScroll() {
    travelled += Math.abs(window.scrollY - last);
    last = window.scrollY;
    /* While the page is moving it is out of the way: an expanded label under a
       moving thumb is something to be tapped by accident. */
    if (wa.classList.contains('is-open')) {
      clearTimeout(shut);
      wa.classList.remove('is-open');
    }
    clearTimeout(waiting);
    clearTimeout(resting);
    resting = setTimeout(function () {
      if (opened >= 2) {
        window.removeEventListener('scroll', onScroll);
        return;
      }
      /* Read a long way, and stopped: the question has had time to form. */
      if (travelled > 2200) {
        travelled = 0;
        open(5000);
      }
    }, 900);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
})();
